import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { BrMaskerModule } from "brmasker-ionic-3";
import { IonicPageModule } from "ionic-angular";
import { IonicModule } from "ionic-angular/module";
import { CommonComponentsModule } from "../../components/common/common-components.module";
import { ComponentsModule } from "../../components/components.module";
import { ActivityLogEditPage } from "./activity-log-edit/activity-log-edit";
import { CompanyResourcesPage } from "./company-resources";
import { CompanyResourcesContactPage } from "./company-resources-contact/company-resources-contact";
import { CompanyResourcesEditPage } from "./company-resources-edit/company-resources-edit";
import { CompanyResourcesNavigation } from "./company-resources-navigation/company-resources-navigation";
import { AccountContactDetails } from "./contact-details/account/account-contact-details";
import { ContactDetails } from "./contact-details/contact-details";
import { EmployeeHealthContactDetails } from "./contact-details/employee-health/employee-health-contact-details";
import { GeneralContactDetails } from "./contact-details/general/general-contact-details";
import { JobRoleContactDetails } from "./contact-details/job-role/job-role-contact-details";
import { ScheduleContactDetails } from "./contact-details/schedule/schedule-contact-details";
import { SkillsAndInterestsContactDetails } from "./contact-details/skills-and-interests/skills-and-interests-contact-details";

@NgModule({
  declarations: [
    CompanyResourcesContactPage,
    CompanyResourcesEditPage,
    CompanyResourcesPage,
    CompanyResourcesNavigation,
    ContactDetails,
    GeneralContactDetails,
    JobRoleContactDetails,
    EmployeeHealthContactDetails,
    AccountContactDetails,
    SkillsAndInterestsContactDetails,
    ScheduleContactDetails,
    ActivityLogEditPage,
  ],
  imports: [
    IonicPageModule.forChild(CompanyResourcesPage),
    TranslateModule.forChild(),
    CommonComponentsModule,
    ComponentsModule,
    FontAwesomeModule,
    IonicModule,
    ReactiveFormsModule,
    NgSelectModule,
  ],
  entryComponents: [
    CompanyResourcesContactPage,
    CompanyResourcesEditPage,
    ContactDetails,
    GeneralContactDetails,
    JobRoleContactDetails,
    AccountContactDetails,
    SkillsAndInterestsContactDetails,
    ScheduleContactDetails,
    ActivityLogEditPage,
  ],
  exports: [
    BrMaskerModule,
    CompanyResourcesNavigation,
    GeneralContactDetails,
    JobRoleContactDetails,
    AccountContactDetails,
    SkillsAndInterestsContactDetails,
    ScheduleContactDetails,
  ],
})
export class CompanyResourcesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/company-resources/company-resources.module.ts